import { createSlice } from '@reduxjs/toolkit';
import { MarkerTypes } from '../constants/general';
import MarkerModel from '../models/markerModel';
import _ from 'lodash';

const initialState = {
    markerSelectionMode: 'rectangle',
    orderMarkers: [],
    orderMarkersVisibility: true,
    routePlanner: {
        start: null,
        end: null,
    }
}

export const slice = createSlice({
    name: 'mapMarker',
    initialState,
    reducers: {
        addNewOrderMarkers: (state, action) => {
            let orders = []
            if (!Array.isArray(action.payload)){
                orders.push(action.payload)
            } else {
                orders = action.payload
            }

            orders.forEach((order)=>{
                let packId = null
                if(order.pack_id > 0){
                    packId = order.pack_id.toString()
                }
                state.orderMarkers.push(
                    new MarkerModel(
                        order.order_id,
                        MarkerTypes.NORMAL,
                        {
                            position: {
                                lat: Number(order.lat),
                                lng: Number(order.lng)
                            },
                            label: packId
                        }
                    ) 
                )
            })
        },
        removeMarker: (state, action) => {
            let orderIds = []
            if(!Array.isArray(action.payload)){
                orderIds.push(action.payload)
            } else {
                orderIds = action.payload
            }

            state.orderMarkers = _.filter(state.orderMarkers, (marker)=>{
                return _.indexOf(orderIds, marker.id) === -1
            })
        },
        resetOrderMarker: (state) => {
            state.orderMarkers = initialState.orderMarkers
        },
        showOrderMarkerVisibility: state =>{
            state.orderMarkersVisibility = true
        },
        hideOrderMarkerVisibility: state =>{
            state.orderMarkersVisibility = false
        },
        setRouteStartPoint: (state, action) => {
            state.routePlanner = {
                ...state.routePlanner,
                start: action.payload
            }
        },
        setRouteEndPoint: (state, action) => {
            state.routePlanner = {
                ...state.routePlanner,
                end: action.payload
            }
        },
        setMarkerSelectionMode: (state, action) => {
            state.markerSelectionMode = action.payload
        }
    }
})

export const getOrderMarkers = state => state.mapMarker.orderMarkers;

export const getOrderMarkerVisibility = state => state.mapMarker.orderMarkersVisibility;

export const getRoutePlanner = state => state.mapMarker.routePlanner;

export const getMarkerSelectionMode = state => state.mapMarker.markerSelectionMode;

export const {
    addNewOrderMarkers, 
    removeMarker,
    resetOrderMarker,
    showOrderMarkerVisibility, 
    hideOrderMarkerVisibility,
    setRouteStartPoint,
    setRouteEndPoint,
    setMarkerSelectionMode
} = slice.actions;

export default slice.reducer;